
import { IServiceMap } from '@/business/BusinessFormData'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Component, Vue } from 'vue-property-decorator'
import BasePage from '../BasePage.vue'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import XdocProjectPlanForFbd from '../components/XdocProjectPlanForFbd.vue'
import _ from 'lodash'
import { getOrgConfig, setOrgConfig } from '@/api/placeOrder'
import { Getter } from 'vuex-class'
import { IFormMap } from '@/store/modules/formMap'
import { getDefaultForm } from '../helper'
import { ICustomerAppKey, IOrganization } from '@/store/state'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
    XdocProjectPlanForFbd,
  },
})
export default class PlaceOrder extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  titleList: string[] = []
  type = ''
  name = ''
  reEdit = false

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }

  FormChange(form: IOrderForm) {
    this.form = form
  }

  async InitCompleted() {
    const orgConfig = await getOrgConfig({ customer_id: this.organization.id })
    const fbdConfig = orgConfig.fbd_align_config
    if (fbdConfig) {
      // 去重
      const titleList = [...(this.form.xdoc_planning?.[0]?.config?.stu2tea_title || []), ...fbdConfig.titleList].filter(
        (item, index, arr) => arr.indexOf(item) === index,
      )
      this.titleList = titleList
    }
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (this.form.material.type === 0 && !this.form.material.oss_fbd_zips?.length)
      return this.$message.error('请上传zip文件')

    // 检查是否有制作内容
    if (!this.form.xdoc_planning?.length) {
      this.$message.error('请选择要制作的内容')
      return callback(true)
    }

    // 检查名称是否重复
    const names = this.form.xdoc_planning.map(item => item.name)
    if (Array.from(new Set(names)).length !== this.form.xdoc_planning.length) {
      this.$message.error('制作内容中有重名项目')
      return callback(true)
    }

    for (const plan of this.form.xdoc_planning) {
      console.log(plan)

      // 检查名称是否包含非法字符
      if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(plan.name || '')) {
        this.$message.error('制作内容含有非法字符')
        return callback(true)
      }

      // 检查正文fbd文件
      if (!plan.origin_files!.filter(fbd => fbd.type === 1).length) {
        this.$message.error('制作内容中未选择正文fbd文件')
        return callback(true)
      }

      // 如果需要答案文件
      if (plan.config.fbd_type === 1) {
        // 检查答案fbd文件
        if (this.form.material.type !== 1) {
          if (!plan.origin_files!.filter(fbd => fbd.type === 0).length) {
            this.$message.error('制作内容中未选择答案fbd文件')
            return callback(true)
          }
        }
      }

      // 是否选择了模板
      if (!plan.config.stu2tea_config_name) {
        this.$message.error('请选择学转教样式')
        return callback(true)
      }
    }
    return callback(false)
  }

  async saveTitleList(titleList: any) {
    this.form.xdoc_planning.map((plan: any) => {
      this.$set(plan.config, 'stu2tea_title', titleList)
    })
    await setOrgConfig({
      customer_id: this.organization.id,
      fbd_align_config: {
        titleList,
      },
    })
    this.$message.success('保存成功')
  }

  BeforeSubmit() {
    this.form.xdoc_planning.map((plan: any) => {
      if (plan.config?.stu2tea_config) {
        this.$set(plan.config.stu2tea_config, 'grade', this.form.stage)
        this.$set(plan.config.stu2tea_config, 'subject', this.form.subject)
      }
    })
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }
}
